// extracted by mini-css-extract-plugin
export default {"DashboardWrapper":"Dashboard_DashboardWrapper__Fcs2I"};